'use client';

import { TableColumnDateText, tableColumnDateTextTag } from '@ni/nimble-components/dist/esm/table-column/date-text';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnDateTextTag };
export { type TableColumnDateText };
export const NimbleTableColumnDateText = wrap(TableColumnDateText);
